import { ActionTypes } from '../constants';
import initialState from './initialState';

export default (state = initialState.mobileAppVersions, action) => {
  switch (action.type) {
    case ActionTypes.GET_MOBILE_APP_VERSIONS_SUCCESS:
      return {
        ...state,
        config: action.payload.config || initialState.mobileAppVersions.config,
        storeVersions: action.payload.storeVersions || initialState.mobileAppVersions.storeVersions
      };
    default:
      return state;
  }
};
